import { render, staticRenderFns } from "./delivery-notes.vue?vue&type=template&id=dc618ca8&"
import script from "./delivery-notes.vue?vue&type=script&lang=js&"
export * from "./delivery-notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports